import { createSvgIcon } from '@mui/material/utils'

export const Location = createSvgIcon(
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M10.0001 18C10.0001 18 16.261 12.4348 16.261 8.26087C16.261 4.80309 13.4579 2 10.0001 2C6.54231 2 3.73922 4.80309 3.73922 8.26087C3.73922 12.4348 10.0001 18 10.0001 18Z' stroke-width='1.66667' />
    <path d='M12.0003 8.00013C12.0003 9.1047 11.1049 10.0001 10.0003 10.0001C8.89578 10.0001 8.00035 9.1047 8.00035 8.00013C8.00035 6.89556 8.89578 6.00013 10.0003 6.00013C11.1049 6.00013 12.0003 6.89556 12.0003 8.00013Z' stroke-width='1.66667' />
  </svg>
)
